import { apiSlice } from "../../api/ApiService";
import { getHeadersFromRedux } from "../../utility/functions/common-functions";

const saveContentStatusApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    saveContentStatus: builder.mutation({
      query: ({ body }) => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/Patient/caseplan-milestone`,
          method: "PUT",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error) => [
        { type: "CarePlanDetails" },
        { type: "MilestoneProgressBar", id: "LIST" },
        { type: "RewardWidget" },
        { type: "LearningWidget" },
        { type: "LearningLibraryContent" },
        { type: "RewardProgressWidget" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useSaveContentStatusMutation } = saveContentStatusApi;
export default saveContentStatusApi;
